import BaseCard from "../../../components/ui/BaseCard";
import BaseDigitalSignature from "../../../components/ui/BaseDigitalSignature";
import BaseTextField from "../../../components/ui/BaseTextField";
const ClientSignature = ({ formik, mode }) => {
  return (
    <BaseCard
      className="pt-4 pb-6 xl:px-16 px-5 rounded-none !mb-[0px] w-full"
      elevation={0}
    >
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="!text-primary">Customer Sign-Off</h6>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div className="grid grid-cols-2">
          <div className="grid grid-cols-2 gap-6 col-span-2">
            <BaseTextField
              disabled={mode !== "WRITE"}
              label="Name"
              labelShrink={false}
              optional={false}
              id="clientName"
              name="clientName"
              isDefaultField={false}
              value={formik.values.clientName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientName && Boolean(formik.errors.clientName)
              }
              helperText={formik.touched.clientName && formik.errors.clientName}
            />
            <BaseTextField
              disabled={mode !== "WRITE"}
              label="Designation"
              labelShrink={false}
              optional={false}
              id="clientDesignation"
              name="clientDesignation"
              isDefaultField={false}
              value={formik.values.clientDesignation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientDesignation &&
                Boolean(formik.errors.clientDesignation)
              }
              helperText={
                formik.touched.clientDesignation &&
                formik.errors.clientDesignation
              }
            />
          </div>
        </div>

        <div className="flex gap-10 w-full col-span-2">
          <div
            className={`border rounded w-full ${
              mode === "WRITE" ? "h-55" : "h-auto"
            }`}
          >
            {" "}
            <p className="text-base font-normal ml-3 mt-3">Signature</p>
            {mode === "WRITE" ? (
              <BaseDigitalSignature
                defaultSignature={formik.values.clientSignatureFile}
                handleSignatureCompleted={(image) =>
                  formik.setFieldValue("clientSignatureFile", image)
                }
                onClear={() => {
                  formik.setFieldValue("clientSignatureFile", null);
                }}
              />
            ) : (
              <div className="flex items-center justify-center">
                <img
                  src={formik.values.clientSignatureFile}
                  alt="Profile Preview"
                  className="object-cover max-h-full max-w-full"
                />
              </div>
            )}
          </div>

          <div className=" border rounded w-full">
            <p className="text-base font-normal ml-3 mt-3">
              Comments <span className="text-xs font-light">(If any)</span>
            </p>
            <textarea
              disabled={mode !== "WRITE"}
              className="w-full rounded-md h-36 resize-none p-4  focus:outline-none focus:ring-0 focus:ring-orange-400 text-xs font-[300]"
              id="clientComment"
              name="clientComment"
              value={formik.values.clientComment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientComment &&
                Boolean(formik.errors.clientComment)
              }
              helperText={
                formik.touched.clientComment && formik.errors.clientComment
              }
            ></textarea>
          </div>
        </div>
      </div>
    </BaseCard>
  );
};

export default ClientSignature;
